import { Box, Grid, styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ServiceAgreementCompany } from 'ogp/services/service-agreements.schema';

type CompanyDetailsProps = {
  company: ServiceAgreementCompany['company'];
};

export const CompanyDetails = ({ company }: CompanyDetailsProps) => {
  const { t } = useTranslation('ogp-screen-specific');
  const details = [
    {
      label: t('collegial-lending.customers.detail.company-name.label', {
        defaultValue: 'Bedrijfsnaam',
      }),
      value: company.name,
    },
    {
      label: t('collegial-lending.customers.detail.coc-number.label', {
        defaultValue: 'KvK',
      }),
      value: company.cocNumber,
    },
    {
      label: t('collegial-lending.customers.detail.address.label', {
        defaultValue: 'Adres',
      }),
      value: company.address,
    },
    {
      label: t('collegial-lending.customers.detail.invoice-email.label', {
        defaultValue: 'Mail voor de facturen',
      }),
      value: company.invoiceEmail,
    },
  ];

  return (
    <Grid container spacing={4} role="tabpanel">
      <Grid item xs={12} md={4}>
        {details.map((detail) => (
          <Box key={detail.label} mb={3}>
            <Typography variant="subtitle2">{detail.label}</Typography>
            <Typography variant="body1">{detail.value || '-'}</Typography>
          </Box>
        ))}
      </Grid>
      <Grid item xs={12} md={6}>
        <Typography variant="subtitle2" mb={2}>
          {t('collegial-lending.customers.detail.company-image.label', {
            defaultValue: 'Bedrijfsafbeelding',
          })}
        </Typography>
        {company.profileImageUrl ? (
          <CompanyImage src={company.profileImageUrl} alt={company.name} />
        ) : (
          <Typography variant="body1">-</Typography>
        )}
      </Grid>
    </Grid>
  );
};

const CompanyImage = styled('img')(({ theme }) => ({
  display: 'block',
  maxWidth: '100%',
  width: theme.spacing(40),
  height: theme.spacing(24),
  objectFit: 'cover',
  borderRadius: theme.shape.borderRadius,
}));
